import { setCookie, getCookie } from '~/utils/dom.utils';

// Cookie configuration constants
export const REFERRAL_COOKIE_NAME = 'hb_referral_code';
export const DEFAULT_REFERRAL_COOKIE_EXPIRATION_DAYS = 30; // 30 days as suggested

/**
 * Gets the appropriate cookie domain based on current environment
 */
const getReferralCookieDomain = (): string => {
    return window.location.hostname;
};

/**
 * Sets a secure referral cookie with timestamp and validation
 * @param referralCode - The referral code to store
 * @param expirationDays - Number of days until the cookie expires (default: 30)
 */
export const setReferralCookie = (
    referralCode: string,
    expirationDays: number = DEFAULT_REFERRAL_COOKIE_EXPIRATION_DAYS
): void => {
    // if referralCode is empty or code exists but there's already a referral cookie, don't set it
    if (!referralCode || getReferralCookie()) {
        return;
    }

    setCookie({
        cookieName: REFERRAL_COOKIE_NAME,
        cookieValue: referralCode,
        expirationDays,
        domain: getReferralCookieDomain()
    });
};

/**
 * Retrieves and validates the referral code from the secure cookie
 * @returns The stored referral code or null if not found/invalid
 */
export const getReferralCookie = (): string | null => {
    const referralCode = getCookie(REFERRAL_COOKIE_NAME);

    return referralCode;
};

/**
 * Removes the referral cookie (typically called after successful referral application)
 */
export const clearReferralCookie = (): void => {
    // Set cookie with expiration in the past to delete it
    setCookie({
        cookieName: REFERRAL_COOKIE_NAME,
        cookieValue: '',
        expirationDays: -1,
        domain: getReferralCookieDomain()
    });
};

/**
 * Gets the referral code from either query parameter or secure cookie, with query param taking precedence
 * @param queryParamCode - The referral code from URL query parameter
 * @returns The referral code to use, or null if none found
 */
export const getEffectiveReferralCode = (
    queryParamCode?: string | null
): string | null => {
    // Priority: Query parameter > Validated Cookie > null
    return getReferralCookie() || queryParamCode;
};
